import apiClient from 'apiClient';
import { AxiosPromise } from 'axios';
import { Manager } from 'screens/Panel/screens/Firm/screens/Managers/api/types';

export const fetchManagers = (firmId: string): AxiosPromise<Manager[]> =>
  apiClient.get(`/api/v1/broker-management/firm/${firmId}/admins`);

export const updateManagerStatus = (managerId: number, isVerified: boolean) =>
  apiClient.post(`/api/v1/broker-management/admin/verify/${managerId}`, { is_verified: isVerified });
